var swiper2 = new Swiper(".productSwiper", {
  loop: false,
  spaceBetween: 16,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

var swiper3 = new Swiper(".productSwiper2", {
  loop: false,
  zoom: true,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper2,
  },
});

// var swiper4 = new Swiper(".multipleProductSwiper", {
//   loop: false,
//   zoom: true,
//   spaceBetween: 16,
//   slidesPerView: 4,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   }
// });

swiper3.on("slideChangeTransitionStart", function (element) {
  const mediaType = swiper3.slides[swiper3.activeIndex].dataset.mediaType;
  const zoomBtn = document.querySelector(".zoom-btn");
  console.log("slideChangeTransitionStart", mediaType);
  if (mediaType === "image") {
    zoomBtn.classList.add("d-block");
    zoomBtn.classList.remove("d-none");
  } else {
    zoomBtn.classList.add("d-none");
    zoomBtn.classList.remove("d-block");
  }
});

const zoomInBtn = document.querySelectorAll(".zoom-image-in");
const zoomOutBtn = document.querySelectorAll(".zoom-image-out");
const swiperContainer = document.querySelector(".productSwiper2");

zoomInBtn.forEach((element) => {
  element.addEventListener("click", () => {
    swiper3.update();
    swiper3.zoom.in(5);
    swiperContainer.style.cursor = "move";
  });
});

zoomOutBtn.forEach((element) => {
  element.addEventListener("click", () => {
    swiper3.update();
    swiper3.zoom.out();
    swiperContainer.style.cursor = "default";
  });
});
